const BrandingPortfolio = () => {
  return <div>Branding portfolio coming soon...</div>;
};

export default BrandingPortfolio;